import isObject from './isObject';

// ----------------------------------------------------------------------------

function iterationCopy(obj: Record<string, any>): Record<string, any> {
    //
    const target: Record<string, any> = {};

    // Foreach Object
    for (const key in obj) {
        if (Object.hasOwn(obj, key)) {
            const value = obj[key];

            // Recursively copy if value is an object
            target[key] = isObject(value) ? iterationCopy(value) : value;
        }
    }

    //
    return target;
}

// ----------------------------------------------------------------------------

export default iterationCopy;
